// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import './InterviewCard.css';
import mainLogo from '../../../assets/images/accellorAILabs_logo_s.svg';

interface InterviewCardProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

const InterviewCard: React.FC<InterviewCardProps> = ({ children, showHeader = true }) => {
  return (
    <div className="interview-card">
      {showHeader && (
        <div className="interview-card-header">
          <div className="interview-card-logo">
            <img src={mainLogo as unknown as string} alt="Accellor Logo" width={25} height={25} />
          </div>
          <h1 className="interview-card-title">Interviewer Host</h1>
        </div>
      )}
      <div className="interview-card-content">{children}</div>
    </div>
  );
};

export default InterviewCard;
